import * as types from "./actionTypes";

export function dispatchActionData(type, data) {
  return { type: type, data: data };
}
//action creator for toggling APICall flag, to render overlay globally.
export function openBackdropOverlay(data) {
  return function (dispatch) {
    dispatch(dispatchActionData(types.OPEN_BACKDROP_OVERLAY, data));
  };
}
export function closeBackDropOverlay() {
  return function (dispatch) {
    dispatch(dispatchActionData(types.CLOSE_BACKDROP_OVERLAY));
  };
}
